module.exports = require('./CollectionPage')